<template>
  <div class="wrapper">
    <div class="container">
      <div class="md-layout">
        <div
          class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
        >
          <h2 class="title text-center">{{ $t("landing.service.titre") }}</h2>
          <h5 class="description">
            {{ $t("landing.service.sous-titre") }}
          </h5>
        </div>
      </div>
      <div class="features text-center">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-info">
                <md-icon>deck</md-icon>
              </div>
              <h4 class="info-title">{{ $t("landing.service.vacances") }}</h4>
              <p>
                {{ $t("landing.service.detail-vacances") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-success">
                <md-icon>menu_book</md-icon>
              </div>
              <h4 class="info-title">{{ $t("landing.service.etudes") }}</h4>
              <p>
                {{ $t("landing.service.detail-etudes") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-warning">
                <md-icon>auto_graph</md-icon>
              </div>
              <h4 class="info-title">{{ $t("landing.service.affaires") }}</h4>
              <p>
                {{ $t("landing.service.detail-affaires") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-danger">
                <md-icon>work</md-icon>
              </div>
              <h4 class="info-title">{{ $t("landing.service.travail") }}</h4>
              <p>
                {{ $t("landing.service.detail-travail") }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="features text-center">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-success">
                <md-icon>hotel</md-icon>
              </div>
              <h4 class="info-title">
                {{ $t("landing.service.hebergement") }}
              </h4>
              <p>
                {{ $t("landing.service.detail-hebergement") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-default">
                <md-icon>corporate_fare</md-icon>
              </div>
              <h4 class="info-title">
                {{ $t("landing.service.immigration") }}
              </h4>
              <p>
                {{ $t("landing.service.detail-immigration") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-warning">
                <md-icon>school</md-icon>
              </div>
              <h4 class="info-title">{{ $t("landing.service.bourses") }}</h4>
              <p>
                {{ $t("landing.service.detail-bourses") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-danger">
                <md-icon>navigation</md-icon>
              </div>
              <h4 class="info-title">{{ $t("landing.service.guide") }}</h4>
              <p>
                {{ $t("landing.service.detail-guide") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page"
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
